import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { WtfAnimations } from '../../../../utils/others/core/animations';


@Component({
  selector: 'mat-section',
  templateUrl: './mat-section.component.html',
  styleUrls: ['./mat-section.component.scss'],
  animations: WtfAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class MatSectionComponent implements OnInit {


  @Input() caption: string;
  @Input() addButton: boolean;



  constructor() { }


  ngOnInit() {
  }


}
